module.exports = __webpack_public_path__ + "img/Balls.60c4a082.png";